import React from "react";
import { Box, Button } from "@mui/material";
import styled from "styled-components";
import { observer } from "mobx-react";

import { useRootStore } from "../../Stores/RootStore";
import { useSurveyStore } from "../../Stores/SurveyStore";
import { RecordingAnime } from "../Svg/Components/RecordingAnime";

const Icon = styled.div`
  font-size: 115px;
  color: #fff;
  position: relative;
  left: 8px;
`;

const VideoBlock = styled(Box)`
  background-color: #000;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

const StyledButton = styled(Button)`
  background-color: ${({ secondary }) => (secondary ? "#ccc" : "#a02200")};
  color: ${({ secondary }) => (secondary ? "#444" : "#fff")};
  border-radius: 0px;
  width: 66%;
  font-size: 12px;
  letter-spacing: initial;
  text-transform: none;
  font-weight: bold;
  border: none;
  padding: 8px;
  font-family: montserrat;
  :hover {
    background-color: ${({ secondary }) => (secondary ? "#ccc" : "#a02200")};
  }
`;

const ButtonGroup = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const Instructions = styled.p`
  text-align: center;
  font-family: inter;
  border: solid 1px #dde;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: #fafafa;
  margin-bottom: 2.5rem;
  margin-top: 0;
`;

function UploadRecordPrompt() {
  const { rootState } = useRootStore();
  const surveyStore = useSurveyStore();

  const setRecording = () => {
    rootState.setInVideoFlow(true);
    rootState.promptForGyro();
  };

  const goBack = () => {
    surveyStore.setCurrentRoom(null);
    surveyStore.setRoomOpen(false);
  };

  return (
    <VideoBlock>
      <Icon>
        <svg height="100%" width="100%" viewBox="0 0 1920 1080">
          <text
            x="5%"
            fontSize="225"
            y="155"
            fill="#a02200"
            fontFamily="telegraf"
            color="#a02200"
          >
            VMT Snapshot
          </text>
          <path
            fill="#a02200"
            d="M596.5 190.6c39.3 4.3 75.5 15 111.5 33.1 21.7 10.8 34.3 18.6 52.3 32.2 64.7 48.5 109 118 126.2 197.6 8.4 38.9 9.7 87.1 3.4 125.9-6.4 39.1-21.9 81.5-42 114.8-3.3 5.4-5.9 10-5.9 10.3 0 .3 2.8.5 6.1.3l6.2-.3 69.3-197C961.8 399.1 993 310.4 993 310.2c0-.1 43.2-.2 95.9-.2h95.9l1.5 4.2c1.6 4.6 154.3 438.4 155.9 443l1 2.8h76.8V409h-102v-99h329v99l-50.7.2-50.8.3v350l50.8.3 50.7.2v100l-197.6-.2-197.6-.3-19.7-56-19.8-56H965.6l-19.7 55.8C935 834 926 859.4 925.7 859.6c-.2.2-90.6 0-200.8-.5l-200.4-.9-16-2.5C412.9 840.5 332 789 279.1 709.5c-30-45.2-47.8-94.6-54.3-151-1.9-17-1.6-62.2.5-77.4 8.3-57.9 27.3-106 60.5-153 13.8-19.6 37.7-45.4 56.2-60.8 56.9-47.4 125.2-74.2 200-78.7 11.3-.6 39.9.4 54.5 2ZM529 216.1c-4.734.438-10.766 1.223-16.962 2.175-.072.35-14.505 3.107-14.596 3.486-2.601 10.9-25.667 46.083-38.738 71.631L602.5 291l159-.1-4-3.5c-7.7-6.9-26.3-20.4-37.1-26.9-39.7-24.2-83.6-39.2-128.4-44-14.7-1.6-47.6-1.8-63-.4Zm-116.5 33.628c-20.2 13.6-39.276 23.3-55.776 39.8-28.2 28.3-55.08 58.6-70.68 94.1-5.9 13.4-23.768 52.748-23.768 56.348 0 2 45.172 85.336 46.272 85.336.3 0 41.952-73.112 74.952-130.312l57.595-99.998c42.422-69.757 39.734-68.429 41.113-70.843-18.193 7.145-53.883 15.019-69.708 25.569ZM778.6 306h-76.8l1.9 3.2c1 1.8 36.9 64 79.8 138.2 70.1 121.3 78 134.6 78.7 132 3.8-14.8 5.9-60.4 3.9-83.3-6.1-68.4-33.5-130.6-80.5-182.4l-7-7.7Zm-160.9 51h-16.9c-12.6 0-17 .3-17.3 1.2-.3.7-3.3 11.6-6.8 24.3l-6.4 23 12.4.3 12.3.3V447h11v-41h12.6c11.5 0 12.6-.2 12.2-1.8-.3-.9-3.3-11.9-6.8-24.5l-6.3-22.7Zm471.4 40.8c-.5-.6-89.2 250.5-89.1 252.4 0 1 178 1.1 178 .1 0-.4-19.9-57.2-44.1-126.2-24.3-69.1-44.5-125.9-44.8-126.3Zm-490.6 63.7-91-.2c-50 0-92.3.2-94 .6-13.9 3.5-26.5 18.3-26.5 31.1v4h11.8c17.8 0 24.7 3.2 30.7 14.1 2.6 4.9 2.9 6.5 3.3 17.1l.4 11.8H579v-11.3c0-9.6.3-11.9 2.4-16.2 2.6-5.6 8-10.9 14-13.6 3.3-1.5 6.6-1.9 17-1.9h12.9l-.7-5.3c-1.6-11.6-8.8-21.7-19.4-26.9l-6.7-3.3Zm-340.4 2.6c-.7-1.1-1-.7-1.5 1.5-3.8 17.4-5.7 61.9-3.7 84.1 4.9 51.4 21.9 99.6 50.6 142.8 8.9 13.4 26.4 35.4 33.7 42.3l3.4 3.2 38-.2 38-.3-78.8-136c-43.4-74.8-79.3-136.6-79.7-137.4ZM390.8 510c-19.1 0-22.1.7-26.2 6.3-2 2.7-2.1 4.2-2.4 41.4-.3 36.9-.2 38.7 1.7 42.7 1.2 2.3 3.5 5 5.3 6.1 3.2 2 5.6 2 136.8 2 126.6 0 133.7-.1 136.8-1.8 1.8-1 4.2-3.2 5.2-5 1.9-3 2-5.3 2-42.3 0-39 0-39.1-2.3-42.5-4.1-6.1-7-6.9-26.7-6.9-19.3 0-22.3.7-26.4 6.3-1.9 2.6-2.1 4.5-2.4 20.3l-.3 17.4H420.2l-.4-16.8c-.3-19-1.3-21.8-8-25.3-3.2-1.7-6-1.9-21-1.9Zm330.2 0h-57v52h57v-52Zm97 29c-1.1 0-159 273.5-158 273.8 1.7.6 24.1-8.9 40-16.9 54.8-27.7 99.8-71.4 129.8-126.4 8.8-16.1 15.1-30.6 21.7-49.9l5.1-15-19-32.8c-10.4-18-19.2-32.8-19.6-32.8Zm-69 37h-85v57h85v-57Zm-329 46h-42v11h42v-11Zm216 0h-41v11h41v-11ZM516.4 754c-142.1 0-158.5.2-157.4 1.5 4.1 4.9 33.3 25.8 47.1 33.7 44.3 25.5 92.7 39.1 143.4 40.5 28 .8 54.6-1.7 77.9-7.3 5.4-1.3 10-2.5 10.1-2.6.6-.8 37.5-65.1 37.5-65.4 0-.2-71.4-.4-158.6-.4Z"
          />
        </svg>
      </Icon>
      <RecordingAnime />

      <Instructions>Stand still in a corner and scan each room.</Instructions>
      <ButtonGroup>
        <StyledButton onClick={setRecording}>Record Video</StyledButton>
        <StyledButton onClick={goBack} secondary={1}>
          Go Back
        </StyledButton>
      </ButtonGroup>
    </VideoBlock>
  );
}

export default observer(UploadRecordPrompt);
